module.exports = __webpack_public_path__ + "img/nissin-2.2c23b316.jpg";